module.exports = __webpack_public_path__ + "static/media/side_3.0ebffbd9.png";